export default {
  myAvailabilities: [],
  availabilities: [],
  mySchedules: [],
}
